import React from "react";
import { useNavigate } from "react-router-dom";
import SourceIQLogo from "../UILibrary/SourceIQLogo";

const Footer = ({ navigateToSignUp }) => {
  const navigate = useNavigate();
  const handleRedirect = (selectedPage) => {
    navigate(
      `/legal/${
        selectedPage === "Terms and Conditions"
          ? "terms-of-use"
          : selectedPage === "Privacy Policy"
          ? "privacy-policy"
          : "ccpa-policy"
      }`
    );
  };

  const socialLinks = {
    linkedin: "https://www.linkedin.com/company/talkdei/",
    instagram: "https://www.instagram.com/talkdei/",
    facebook: "https://www.facebook.com/TalkDEI/",
    medium: "https://medium.com/@Talkdei",
  };

  const handleSocialRedirect = (platform) => {
    const url = socialLinks[platform];
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      console.error("Invalid platform:", platform);
    }
  };

  return (
    <div className="h-[280px] sm:h-[320px] md:h-[400px] lg:h-[451px] bg-[#eaf524] overflow-hidden pl-8 pt-[25px] md:pt-[45px] pb-[30px] w-full flex flex-col justify-between sm:pl-12 md:pl-28">
      <div className="flex flex-row justify-between items-start gap-[20px]">
        <div className="flex flex-col text-left gap-[8px] sm:g-[16px] md:g-[18px] lg-g-[20px] w-[133px] sm:w-[302px] md:w-[378px] lg:w-[426px]">
          <SourceIQLogo
            fill="#1E1E1E"
            className="w-[76px] sm:w-[153px] md:w-[160px] lg:w-[180px] h-[13px] sm:h-[25px] md:h-[28px] lg:h-[30px]"
          />

          <span className="text-[#1E1E1E] text-[11px] sm:text-[17px] md:text-[21px] lg:text-[24px] w-full">
            We value your privacy and ensure your information is protected
          </span>

          <button
            onClick={navigateToSignUp}
            className="w-[143px] sm:w-[224px] md:w-[280px] lg:w-[315px] flex  p-[8px] sm:p-3 md:p-4 lg:p-5 bg-[#1e1e1e] rounded-[5px] sm:rounded-[13px] justify-center items-center gap-2"
          >
            <span className="text-center text-[#eaf524] text-[7px] sm:text-xs md:text-sm lg:text-[16px] font-medium font-['Hanken Grotesk']">
              Get Early Access to Smart Sourcing
            </span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="5"
              height="5"
              viewBox="0 0 12 14"
              fill="none"
              className="cursor-pointer sm:w-[8px] sm:h-[9px] md:w-[10px] md:h-[12px] lg:w-[12px] lg:h-[14px]"
            >
              <path d="M12 7L0 14L6.05683e-07 0L12 7Z" fill="#EAF524" />
            </svg>
          </button>
        </div>

        {/* LEGAL LINKS */}
        <div className="flex flex-col text-left mr-[15px] md:mr-[37px] text-[11px] sm:text-[14px] md:text-[18px] lg:text-[24px]">
          <span className="text-[#1E1E1E] font-bold leading-[140%] mb-[10px]">
            LEGAL
          </span>
          <p
            onClick={() => handleRedirect("Terms and Conditions")}
            className="text-[#1E1E1E] font-normal leading-[183%] cursor-pointer"
          >
            Terms & Conditions
          </p>
          <p
            onClick={() => handleRedirect("Privacy Policy")}
            className="text-[#1E1E1E] font-normal leading-[183%] cursor-pointer"
          >
            Privacy Policy
          </p>
          <p
            onClick={() => handleRedirect("CCPA Policy")}
            className="text-[#1E1E1E] font-normal leading-[183%] cursor-pointer"
          >
            CCPA Policy
          </p>
        </div>
      </div>

      {/* SOCIAL MEDIA ICONS */}
      <div className="flex flex-row justify-between items-end gap-[20px]">
        <div className="flex flex-col">
          <span className="text-base sm:text-lg md:text-xl lg:text-2xl font-['Proxima Nova'] mb-4">
            Reach us:
          </span>

          <div className="flex flex-row items-center gap-2 sm:gap-3 md:gap-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className=" cursor-pointer w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8"
              viewBox="0 0 24 24"
              fill="none"
              onClick={() => handleSocialRedirect("facebook")}
            >
              <g clipPath="url(#clip0_5_4276)">
                <path
                  d="M22 11.7757C22 6.23913 17.5234 1.75195 12 1.75195C6.47656 1.75195 2 6.23913 2 11.7757C2 16.7797 5.65625 20.9262 10.4375 21.678V14.6732H7.89844V11.7757H10.4375V9.56732C10.4375 7.05552 11.9297 5.66747 14.2148 5.66747C15.3086 5.66747 16.4531 5.86324 16.4531 5.86324V8.33002H15.1914C13.9492 8.33002 13.5625 9.10333 13.5625 9.89622V11.7757H16.3359L15.8926 14.6732H13.5625V21.678C18.3438 20.9262 22 16.7797 22 11.7757Z"
                  fill="#1E1E1E"
                />
              </g>
              <defs>
                <clipPath id="clip0_5_4276">
                  <rect width="24" height="24" fill="white" />
                </clipPath>
              </defs>
            </svg>
            <div className="h-5 w-px bg-[#1E1E1E] sm:h-6 md:h-8"></div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="cursor-pointer w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8"
              viewBox="0 0 21 21"
              fill="none"
              onClick={() => handleSocialRedirect("instagram")}
            >
              <path
                d="M11.2547 0.356445C16.3291 0.356445 20.4809 4.50825 20.4809 9.58269V11.0242C20.4809 16.0986 16.3291 20.2504 11.2547 20.2504H9.81315C4.73872 20.2504 0.586914 16.0986 0.586914 11.0242V9.58269C0.586914 4.50825 4.73872 0.356445 9.81315 0.356445H11.2547ZM10.7153 5.35661L10.5869 5.35644C9.51802 5.35644 8.44912 5.39178 8.44912 5.39178C6.88788 5.39178 5.62224 6.65741 5.62224 8.21864C5.62224 8.21864 5.5898 9.13648 5.58709 10.1216L5.58691 10.2504C5.58691 11.3535 5.62224 12.4942 5.62224 12.4942C5.62224 14.0555 6.88788 15.3211 8.44912 15.3211C8.44912 15.3211 9.4485 15.3564 10.4809 15.3564C11.584 15.3564 12.7601 15.3211 12.7601 15.3211C14.3213 15.3211 15.5516 14.0908 15.5516 12.5296C15.5516 12.5296 15.5869 11.4017 15.5869 10.3211L15.5863 10.0675C15.5815 9.09807 15.5516 8.18329 15.5516 8.18329C15.5516 6.62206 14.3213 5.39178 12.76 5.39178C12.76 5.39178 11.7424 5.35922 10.7153 5.35661ZM10.5869 6.25642C11.4634 6.25642 12.5873 6.28541 12.5873 6.28541C13.8675 6.28541 14.6579 7.07585 14.6579 8.35606C14.6579 8.35606 14.6869 9.46071 14.6869 10.3274C14.6869 11.2135 14.6579 12.3568 14.6579 12.3568C14.6579 13.637 13.8675 14.4274 12.5873 14.4274C12.5873 14.4274 11.5934 14.4518 10.7311 14.4558L10.5 14.4564C9.65341 14.4564 8.62189 14.4274 8.62189 14.4274C7.34169 14.4274 6.5159 13.6016 6.5159 12.3214C6.5159 12.3214 6.48691 11.174 6.48691 10.2695C6.48691 9.42291 6.5159 8.35606 6.5159 8.35606C6.5159 7.07585 7.34172 6.28541 8.62189 6.28541C8.62189 6.28541 9.71039 6.25642 10.5869 6.25642ZM10.5869 7.79514C9.17233 7.79514 8.02561 8.94186 8.02561 10.3564C8.02561 11.771 9.17233 12.9177 10.5869 12.9177C12.0015 12.9177 13.1482 11.771 13.1482 10.3564C13.1482 8.94186 12.0015 7.79514 10.5869 7.79514ZM10.5869 8.68974C11.5074 8.68974 12.2536 9.43593 12.2536 10.3564C12.2536 11.2769 11.5074 12.0231 10.5869 12.0231C9.66643 12.0231 8.92022 11.2769 8.92022 10.3564C8.92022 9.43593 9.66641 8.68974 10.5869 8.68974ZM13.2707 7.08437C12.9289 7.08437 12.6518 7.36283 12.6518 7.70631C12.6518 8.04979 12.9289 8.32822 13.2707 8.32822C13.6125 8.32822 13.8896 8.04979 13.8896 7.70631C13.8896 7.36281 13.6125 7.08437 13.2707 7.08437Z"
                fill="#1E1E1E"
              />
            </svg>
            <div className="h-5 w-px bg-[#1E1E1E] sm:h-6 md:h-8"></div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="cursor-pointer w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8"
              viewBox="0 0 21 21"
              fill="none"
              onClick={() => handleSocialRedirect("linkedin")}
            >
              <path
                d="M20.5781 10.3359C20.5781 4.81309 16.101 0.335938 10.5781 0.335938C5.05528 0.335938 0.578125 4.81309 0.578125 10.3359C0.578125 15.8588 5.05528 20.3359 10.5781 20.3359C16.101 20.3359 20.5781 15.8588 20.5781 10.3359Z"
                fill="#1E1E1E"
              />
              <path
                d="M8.16284 5.83075C8.16284 6.49828 7.5842 7.03943 6.87048 7.03943C6.15673 7.03943 5.57812 6.49828 5.57812 5.83075C5.57812 5.16321 6.15673 4.62207 6.87048 4.62207C7.5842 4.62207 8.16284 5.16321 8.16284 5.83075Z"
                fill="#EAF524"
              />
              <path
                d="M5.75488 7.92773H7.96401V14.6219H5.75488V7.92773Z"
                fill="#EAF524"
              />
              <path
                d="M11.5207 7.92725H9.31152V14.6215H11.5207C11.5207 14.6215 11.5207 12.514 11.5207 11.1964C11.5207 10.4055 11.7907 9.61111 12.8682 9.61111C14.086 9.61111 14.0787 10.6461 14.073 11.448C14.0655 12.496 14.0832 13.5657 14.0832 14.6215H16.2924V11.0884C16.2737 8.83247 15.6858 7.79297 13.7519 7.79297C12.6034 7.79297 11.8915 8.3144 11.5207 8.78611V7.92725Z"
                fill="#EAF524"
              />
            </svg>
            <div className="h-5 w-px bg-[#1E1E1E] sm:h-6 md:h-8"></div>

            <svg
              className="cursor-pointer w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8"
              onClick={() => handleSocialRedirect("medium")}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
            >
              <path d="M180.5 74.3C80.8 74.3 0 155.6 0 256S80.8 437.7 180.5 437.7 361 356.4 361 256 280.2 74.3 180.5 74.3zm288.3 10.6c-49.8 0-90.2 76.6-90.2 171.1s40.4 171.1 90.3 171.1 90.3-76.6 90.3-171.1H559C559 161.5 518.6 84.9 468.8 84.9zm139.5 17.8c-17.5 0-31.7 68.6-31.7 153.3s14.2 153.3 31.7 153.3S640 340.6 640 256C640 171.4 625.8 102.7 608.3 102.7z" />
            </svg>
          </div>
        </div>
        <div className="logo-container">
          <SourceIQLogo
            fill="rgba(0, 0, 0, 0.06)"
            opacity={0.28}
            stroke="#1E1E1E"
            strokeWidth={0.6}
          />
        </div>
      </div>
      <p className="mt-2 text-[11px] text-left ">
        &copy; 2025 SourceIQ LLC. All rights reserved.
      </p>
    </div>
  );
};

export default Footer;
